import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectHealthInsurance = ({
  getData,
  selectedHealthInsurance,
  onChange,
  placeholder = 'healthInsurancePlaceholder',
  disabled,
  maskLabel,
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [healthInsurances, setHealthInsurances] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectHealthInsurance = (item) => {
    const healthInsurance = healthInsurances.find((h) => h._id === item.value);
    onChange(healthInsurance);
  };

  const getHealthInsurances = useCallback(
    async (search) => {
      setLoading(true);
      try {
        const params = { search, isServiceCreation: true };
        const { healthInsurances: healthInsurancesList } = await getData(params);
        setHealthInsurances(healthInsurancesList);
      } catch (error) {
        setHealthInsurances([]);
      } finally {
        setLoading(false);
      }
    },
    [getData],
  );

  const getOptionData = useCallback((healthInsurance) => {
    return {
      value: healthInsurance._id,
      label: healthInsurance.name,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t(placeholder)}
      isLoading={loading}
      onChange={selectHealthInsurance}
      options={healthInsurances}
      value={selectedHealthInsurance}
      onSearch={getHealthInsurances}
      getOptionData={getOptionData}
      disabled={disabled}
      maskLabel={maskLabel}
    />
  );
};

SelectHealthInsurance.propTypes = {
  selectedHealthInsurance: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  getData: PropTypes.func,
  disabled: PropTypes.bool,
  maskLabel: PropTypes.func,
};

SelectHealthInsurance.defaultProps = {
  getData: InteroperableDataService.getHealthInsurances,
};
